import { Input as AntdInput } from "antd";
import { createStyles } from "antd-style";

import type { AvE2EProps } from "@av/components/types";

import type { TextAreaProps as AntdTextAreaProps } from "antd/es/input";

type TextAreaProps = AntdTextAreaProps & AvE2EProps;

const useStyles = createStyles(({ css, token }) => ({
  textArea: css`
    &:hover {
      border-color: ${token.colorLinkHover};
    }
    &:active {
      border-color: ${token.colorLinkActive};
    }
  `,
}));

export function CustomTextArea(props: TextAreaProps) {
  const { testIdPrefix, ...rest } = props;
  const { styles } = useStyles();

  return (
    <AntdInput.TextArea
      className={styles.textArea}
      size="middle"
      data-testid={testIdPrefix + "-text-area-input"}
      {...rest}
    />
  );
}
